/**
 * 映像スタイル (visual_style) の定義と判定。
 *
 * useGenerationState.tsx から切り出したもの (ロジック変更なし)。
 * バックエンド (VALID_VISUAL_STYLES) と値を揃えること。
 */

// 映像スタイル。バックエンド (VALID_VISUAL_STYLES) と値を揃えること。
export type VisualStyle =
  // 実写(写実)系ファミリー
  | 'photorealistic' | 'cinematic' | 'documentary' | 'retro_film'
  // アニメ・イラスト系
  | 'anime' | 'anime_3d' | 'watercolor' | 'cartoon' | 'pixel_art'
  // 非写実・グラフィック系
  | 'clay' | 'paper_craft' | 'motion_graphics';

export const VISUAL_STYLES: readonly VisualStyle[] = [
  'photorealistic', 'cinematic', 'documentary', 'retro_film',
  'anime', 'anime_3d', 'watercolor', 'cartoon', 'pixel_art',
  'clay', 'paper_craft', 'motion_graphics',
];

// 写実(実写)系ファミリー。AI俳優・avoid_faces・イラスト絵コンテが引き続き使える。
// これ以外(アニメ/イラスト/グラフィック系)は非写実なので、それらを無効化する。
const PHOTOREAL_VISUAL_STYLES: readonly VisualStyle[] = [
  'photorealistic', 'cinematic', 'documentary', 'retro_film',
];

/** 非写実(アニメ・イラスト・グラフィック)系か。写実系ファミリーは false。 */
export function isStylizedVisualStyle(value: VisualStyle): boolean {
  return !PHOTOREAL_VISUAL_STYLES.includes(value);
}

/** 不明値を既定(photorealistic)に丸めて VisualStyle に正規化する。 */
export function normalizeVisualStyle(value: unknown): VisualStyle {
  return VISUAL_STYLES.includes(value as VisualStyle) ? (value as VisualStyle) : 'photorealistic';
}

/**
 * 任意の visual_style key の stylized 判定。属性ツリー由来 key (OEM 独自含む) に対応する。
 *   1. DB 由来の map (key→visual_family==='stylized') に key があれば最優先
 *   2. ビルトイン12 key はハードコード判定
 *   3. 未知 key は安全側 (photoreal=false。AI俳優等を不必要に塞がない)
 */
export function resolveVisualStyleStylized(
  key: string,
  stylizedMap: Record<string, boolean>,
): boolean {
  if (Object.prototype.hasOwnProperty.call(stylizedMap, key)) return stylizedMap[key];
  if (VISUAL_STYLES.includes(key as VisualStyle)) return isStylizedVisualStyle(key as VisualStyle);
  return false;
}
